import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="s-footer">
      <p>© 2026 Sosta · for the girls, by the girls 💅</p>
      <div className="s-footer-links">
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/terms">Terms of Service</Link>
        <Link to="/support">Support</Link>
      </div>
    </footer>
  );
}
